import { forwardRef } from "react";
import { Chip as MuiChip, ChipProps as MuiChipProps } from "@mui/material";
import styles from "./Chip.styles";

export type TChipProps = MuiChipProps & {
  label: string;
};

const Chip = forwardRef<HTMLDivElement, TChipProps>((props, ref) => {
  return <MuiChip sx={styles.defaultChip} ref={ref} {...props} />;
});

export default Chip;
